export default {
  debug: true,

  teams: [],
  groups: [],
  single: [],
  ladder: [],
  wildcard: [],
  selectedMatchArr: [],
  circuitMatches: [],
  modal: false,
  disabled: false,
  groupStageFinished: false,
  selectedMatch: null,
  circuitModal: false,
  standings: [],
  showFinalStandings: false,
  isCurrentStage: false,
  loading: false,
  innerLoading: false,
  type: null,
  spec: null,
  qty: null,
  competition: null,
  matches: [],
  isVisible: true,
  rounds: [],
  category: "",
  competitionIsOngoing: true,
  renderComponent: true,
  nextStageIsAvailable: false,
  spanCount: '6',
  canSave: false,

  //Schema Select

  updateMatches(newMatches) {
    this.matches = JSON.parse(JSON.stringify(newMatches));
  },
  getSEMatchQty(n) {
    if (n > 1) {
      return n + 2 * this.getSEMatchQty(n / 2);
    }
    return n;
  },
  getWCMatchQty(n) {
    if (n <= 2) {
      if (n > 1) {
        return 3 * n + 1;
      } else return n
    } else return 2 * this.getWCMatchQty(n / 2) + n * 1.5;
  },
  async getCurrentCompetition(src) {
    try {
      const res = await this.$http.post("/competition/find", {
        _id: this.$route.params.id
      });
      this.competition = res.data;
      if (src) {
        this.type = this.competition.formats.find(
          ({ category }) => category._id === this.$route.params.cat
        ).format_type;
        this.qty = this.competition.formats.find(
          ({ category }) => category._id === this.$route.params.cat
        ).group_qty;
        this.spec = this.competition.formats.find(
          ({ category }) => category._id === this.$route.params.cat
        ).spec;
        if (this.type === "group" && this.spec && this.qty)
          this.isVisible = false;
        else if (this.type === "circuit" && this.spec) this.isVisible = false;
        else this.isVisible = true;
        this.matches = [];
        // await this.getAllMatches(this.competition.stages);
      }
    } catch (error) {
      console.log(error);
    }
  },
  forceRerender() {
    this.renderComponent = false;

    this.$nextTick(() => {
      this.renderComponent = true;
    });
  },
  getCategory() {
    // console.log("this.competition", this.competition);
    return this.competition.formats.find(
      cat => cat.category._id === this.$route.params.cat
    ).category;
  },
  async addMoreMatches() {
    if (this.type === "group") {
      const updatedDate = new Date(this.competition.date[1]);
      updatedDate.setDate(updatedDate.getDate() - 7);
      await this.$http.post("/competition/rounds", {
        stageId: this.competition.stages.find(stage => stage.isCurrent)._id,
        rounds: [{ name: "Playoff", date_start: updatedDate, isPlayoff: true, category: this.$route.params.cat }]
      });
    }
    const DBMatches = await this.$http.post("/match/addMany", this.matches);
    await this.getCurrentCompetition(false);
    // this.forceRerender();
  },
  async saveRounds(roundsToPush) {
    this.rounds = JSON.parse(JSON.stringify(roundsToPush));
  },
  async save() {
    // this.loading = true;
    try {
      await this.$http.post("/competition/format", {
        _id: this.$route.params.id,
        category: this.$route.params.cat,
        format_type: this.type,
        group_qty: this.qty,
        spec: this.spec
      });
      if (this.type === "group") {
        const updatedDate = new Date(this.competition.date[1]);
        updatedDate.setDate(updatedDate.getDate() - 7);
        await this.$http.post("/competition/rounds", {
          stageId: this.competition.stages.find(stage => stage.isCurrent)._id,
          rounds: [
            { name: "Playoff", date_start: updatedDate, isPlayoff: true, category: this.$route.params.cat }
          ]
        });
      }
      const DBMatches = await this.$http.post("/match/addMany", this.matches);
      await this.getCurrentCompetition(true);
      // this.loading = false;
      this.forceRerender();
    } catch (error) {
      console.log("error :>> ", error);
    }
  },
  close(src) {
    console.log('closed');
    // const finishedMatches = this.matches.filter(item => !item.isFinished);

    // if (!finishedMatches.length && this.type === 'circuit') {
    //   await this.detectCurrentStage();
    // }

    this.circuitModal = false;
    console.log(src);
    if (src) {
      this.forceRerender()
    }
  },
  async getDisqualified(match) {
    try {
      const res = await this.$http.post("/team/disqualified", {
        teamId: match.home_team._id,
        matchId: match._id
      });
    } catch (error) {
      console.log("home", error);
    }
    try {
      const res = await this.$http.post("/team/disqualified", {
        teamId: match.away_team._id,
        matchId: match._id
      });
    } catch (error) {
      console.log("away", error);
    }
  },
  getMatcheStadium(item) {
    let ifStadium = item.stadium ? item.stadium : item.stage.stadium;
    return ifStadium;
  },
  async getUpdatedCompetition() {
    try {
      const res = await this.$http.post("/competition/find", {
        _id: this.$route.params.id
      });
      this.competition = res.data;
    } catch (e) {
      console.log(e);
    }
  },
  async setCurrentStage(_id, isCurrent) {
    try {
      const res = await this.$http.post("/competition/editStage", {
        _id,
        isCurrent
      });
    } catch (e) {
      console.log(e);
    }
  },
  async detectCurrentStage() {
    this.loading = true
    for (let i = this.competition.stages.findIndex(({ isCurrent }) => isCurrent); i < this.competition.stages.length; i++) {
      const stage = this.competition.stages[i];
      const res = await this.$http.post("/match/list", { stage: stage._id });
      if (
        res.data.length &&
        res.data.every(match => match.isFinished) &&
        (this.type === "group" ? this.showFinalStandings : true)
      ) {
        await this.setCurrentStage(stage._id, false);
        if (i === this.competition.stages.length - 1) {
          this.competitionIsOngoing = false;
          await this.getCurrentCompetition(true);
          this.forceRerender();
          setTimeout(() => { this.loading = false }, 500)
          break;
        }
      } else {
        if (!stage.isCurrent) {
          await this.setCurrentStage(stage._id, true);
          if (this.type === "group")
            await this.getUpdatedCompetition();
          this.saveRounds(
            this.competition.stages.find(({ isCurrent }) => isCurrent).rounds
          );
          this.updateMatches([]);
          if (this.type === "circuit")
            await this.getUpdatedCompetition();
          await this.getCurrentTeams();
          // if (this.type === "circuit") {
          //   if (this.spec === "oneway") {
          //     this.checkForMatches();
          //   } else if (this.spec === "twoway") {
          //     this.checkForPairMatches();
          //   }
          // }
          await this.addMoreMatches();
          if (this.type === "group") {
            await this.getCurrentTeams();
            if (this.type === 'group') {
              this.groupStageFinished = false
              this.showFinalStandings = false
              this.single = []
              this.ladder = []
              this.wildcard = []
            }
          }
          this.forceRerender()
          setTimeout(() => { this.loading = false }, 500)
          break;
        }
      }
    }
  },
  async previousStage() {
    this.loading = true
    const actIndex = this.competition.stages.findIndex(({ isCurrent }) => isCurrent)
    await this.setCurrentStage(this.competition.stages[actIndex], false);
    await this.setCurrentStage(this.competition.stages[actIndex - 1], true);
    await this.getUpdatedCompetition();
    await this.getCurrentTeams();
    if (this.type === 'circuit') {
      this.forceRerender()
    } else if (this.type === 'group') {
      window.location.reload()
    }
    setTimeout(() => { this.loading = false }, 500)
  },
  async nextStage() {
    this.loading = true
    const actIndex = this.competition.stages.findIndex(({ isCurrent }) => isCurrent)
    await this.setCurrentStage(this.competition.stages[actIndex], false);
    await this.setCurrentStage(this.competition.stages[actIndex + 1], true);
    await this.getUpdatedCompetition();
    await this.getCurrentTeams();
    if (this.type === 'circuit') {
      this.forceRerender()
    } else if (this.type === 'group') {
      window.location.reload()
    } setTimeout(() => { this.loading = false }, 500)
  },
  async setStage(_id) {
    this.loading = true
    const currentStage = this.competition.stages.find(({ isCurrent }) => isCurrent)._id;
    const stageToChange = this.competition.stages.find((stage) => stage._id === _id)._id;
    await this.setCurrentStage(currentStage, false);
    await this.setCurrentStage(stageToChange, true);
    await this.getUpdatedCompetition();
    await this.getCurrentTeams();
    // window.location.reload()
    if (this.type === 'circuit') {
      this.forceRerender()
    } else if (this.type === 'group') {
      window.location.reload()
    } setTimeout(() => { this.loading = false }, 500)
  },
  async checkStageAvailability(stages) {
    this.loading = true
    try {
      const res = await this.$http.post("/match/getMany", {
        stages: stages,
        category: this.$route.params.cat
      });
      if (res.data.length) {
        this.nextStageIsAvailable = true
      } else { this.nextStageIsAvailable = false }
      setTimeout(() => { this.loading = false }, 500)
      console.log('checked', this.nextStageIsAvailable);
    } catch (error) {
      console.log(error);
      setTimeout(() => { this.loading = false }, 500)
    }
  },
  async getAllMatches(stages) {
    try {
      let results = [];
      const res = await this.$http.post("/match/getMany", {
        stages: stages,
        category: this.$route.params.cat
      });
      results.push(...res.data);
      this.updateMatches(results);
    } catch (error) {
      console.log(error);
    }
  },
  getDateMatches(date) {
    if (date) {
      let dates = new Date(date).toLocaleDateString();
      let replaceDate = dates.replace(/[/]/g, ":");

      const dateStart = new Date(date);
      let startHours = dateStart.getHours();
      let startMinutes = dateStart.getMinutes();

      if (startHours < 10) {
        startHours = "0" + startHours;
      }

      if (startMinutes < 10) {
        startMinutes = "0" + startMinutes;
      }

      let hours = startHours + ":" + startMinutes;

      return `${replaceDate}; ${hours}`;
    } else {
      return "";
    }
  },
  async generateRounds() {
    const roundsToPush = [];
    let currentAmountOfRounds;
    let currentAmountOfRoundsInGroups =
      Math.ceil(this.teams.length / this.groups.length) % 2 === 0
        ? Math.ceil(this.teams.length / this.groups.length - 1)
        : Math.ceil(this.teams.length / this.groups.length);
    let currentAmountOfRoundsInCircuits =
      this.teams.length % 2 === 0 ? this.teams.length - 1 : this.teams.length;
    if (this.type === "group") {
      currentAmountOfRounds = currentAmountOfRoundsInGroups;
    } else if (this.type === "circuit") {
      currentAmountOfRounds = currentAmountOfRoundsInCircuits;
    }
    for (let i = 0; i < currentAmountOfRounds; i++) {
      roundsToPush.push({
        name: "Round " + (i + 1),
        date_start: new Date(),
        stage: this.competition.stages.find(({ isCurrent }) => isCurrent)._id,
        stadium: this.competition.stages.find(({ isCurrent }) => isCurrent)
          .stadium,
        spends: this.competition.stages.find(({ isCurrent }) => isCurrent)
          .spends,
        category: this.$route.params.cat,
        _id: i
      });
    }
    this.saveRounds(roundsToPush);
  },
  async getMatches() {
    try {
      let result = [];
      for (
        let i = 0;
        i <
        this.rounds.filter(
          round => round.category === this.$route.params.cat && !round.isPlayoff
        ).length;
        i++
      ) {
        const element = this.rounds.filter(
          round => round.category === this.$route.params.cat && !round.isPlayoff
        )[i];
        const res = await this.$http.post("/match/list", {
          round: element._id
        });
        result.push(...res.data);
      }
      if (result.length > 0) {
        this.updateMatches(result);
      }
    } catch (error) {
      console.log(error);
    }
  },
  async getCurrentTeams() {
    try {
      const res = await this.$http.post("/team/list", {
        competition_id: this.competition._id,
        category: this.$route.params.cat,
        stageId:
          this.type === "group"
            ? this.competition.stages.find(({ isCurrent }) => isCurrent)._id
            : null
      });
      this.teams = res.data.filter((team) => team.players.length >= team.ttype.max_count);
      if (this.type === "group") { this.formGroups(); }
      if (this.competitionIsOngoing) {
        console.log("pre", this.rounds);
        if (!this.rounds.filter(round => round.category === this.$route.params.cat && round.stage === this.competition.stages.find(({ isCurrent }) => isCurrent)._id).length) {
          this.generateRounds();
        }
        console.log("post", this.rounds);
      }
      if (!this.isVisible) {
        await this.getAllMatches(
          this.competition.stages.filter(({ isCurrent }) => isCurrent)
        );
      }
      if (this.spec === "single") {
        if (
          this.isVisible ||
          !this.matches.filter(
            match =>
              match.stage._id ===
              this.competition.stages.find(({ isCurrent }) => isCurrent)._id
          ).length
        ) {
          this.generateRoundRobinSchedule(false);
        } else {
          await this.goToPlayoffs();
        }
      } else if (this.spec === "stepladder") {
        if (
          this.isVisible ||
          !this.matches.filter(
            match =>
              match.stage._id ===
              this.competition.stages.find(({ isCurrent }) => isCurrent)._id
          ).length
        ) {
          this.generateRoundRobinSchedule(false);
        } else {
          await this.goToPlayoffs();
        }
      } else if (this.spec === "wildcard") {
        if (
          this.isVisible ||
          !this.matches.filter(
            match =>
              match.stage._id ===
              this.competition.stages.find(({ isCurrent }) => isCurrent)._id
          ).length
        ) {
          this.generateRoundRobinSchedule(false);
        } else {
          await this.goToPlayoffs();
        }
      }
      if (this.spec === "oneway") {
        this.checkForMatches();
      } else if (this.spec === "twoway") {
        this.checkForPairMatches();
      }
    } catch (error) {
      console.log("error :>> ", error);
    }
  },
  getPoints(arr, match, team) {
    if (match.tech_loser) {
      if (match.tech_loser === team._id) return 0;
      else return 28;
    }
    return arr.reduce((acc, item) => acc + item.points, 0);
  },
  checkForMatches() {
    console.log(this.matches, this.rounds);
    const matchesMap = new Map();
    if (this.matches.length)
      for (const existingMatch of this.matches) {
        const matchKey = `${existingMatch.home_team._id}-${existingMatch.away_team._id}-${existingMatch.round._id}`;
        matchesMap.set(matchKey, existingMatch);
      }
    if (
      this.isVisible ||
      (this.competition.stages.find(({ isCurrent }) => isCurrent) &&
        this.matches.filter(match => match.stage._id === this.competition.stages.find(({ isCurrent }) => isCurrent)._id).length !==
        (this.teams.length / 2) * this.rounds.filter(round => round.category === this.$route.params.cat).length)
    ) {
      for (const round of this.rounds.filter(
        round => round.category === this.$route.params.cat
      )) {
        for (let i = 0; i < Math.floor(this.teams.length / 2); i++) {
          const homeMatch = {
            home_team: this.teams[i],
            away_team: this.teams[this.teams.length - 1 - i],
            home_players: this.teams[i].players.map(({ player }) => {
              return { player: player, goals: 0, points: 0, cards: [] };
            }),
            away_players: this.teams[this.teams.length - 1 - i].players.map(
              ({ player }) => {
                return { player: player, goals: 0, points: 0, cards: [] };
              }
            ),
            stage: this.competition.stages.find(({ isCurrent }) => isCurrent),
            round: round
          };

          const homeMatchKey = `${homeMatch.home_team._id}-${homeMatch.away_team._id}-${homeMatch.round._id}`;
          if (!matchesMap.has(homeMatchKey)) {
            matchesMap.set(homeMatchKey, homeMatch);
          }
        }
        this.teams.length % 2 === 0
          ? this.teams.splice(1, 0, this.teams.pop())
          : this.teams.splice(0, 0, this.teams.pop());
      }
    }
    // this.matches = Array.from(matchesMap.values());
    this.updateMatches(Array.from(matchesMap.values()));
  },
  checkForPairMatches() {
    const matchesArray = [];
    const matchesMap = new Map();
    if (this.matches.length)
      for (const existingMatch of this.matches) {
        const matchKey = `${existingMatch.home_team._id}-${existingMatch.away_team._id}-${existingMatch.round._id}`;
        const awayMatchKey = `${existingMatch.away_team._id}-${existingMatch.home_team._id}-${existingMatch.round._id}`;
        // console.log("matchesArray", matchesArray)

        if (matchesMap.has(awayMatchKey)) {
          matchesArray.find(
            match => match.home.home_team._id === existingMatch.away_team._id
          ).away = existingMatch;
        }
        if (!matchesMap.has(matchKey)) {
          matchesMap.set(matchKey, existingMatch);
          matchesArray.push({ home: existingMatch, away: null, key: matchKey });
        }
      }
    if (
      this.isVisible ||
      (this.competition.stages.find(({ isCurrent }) => isCurrent) &&
        this.matches.filter(
          match =>
            match.stage._id ===
            this.competition.stages.find(({ isCurrent }) => isCurrent)._id
        ).length !==
        this.teams.length *
        this.rounds.filter(
          round => round.category === this.$route.params.cat
        ).length)
    ) {
      for (const round of this.rounds.filter(
        round => round.category === this.$route.params.cat
      )) {
        for (let i = 0; i < Math.floor(this.teams.length / 2); i++) {
          const homeTeam = this.teams[i];
          const awayTeam = this.teams[this.teams.length - 1 - i];

          if (homeTeam !== awayTeam) {
            const matchKey = `${homeTeam._id}-${awayTeam._id}-${round._id}`;
            const awayMatchKey = `${awayTeam._id}-${homeTeam._id}-${round._id}`;

            if (!matchesMap.has(matchKey)) {
              const homeMatch = {
                home_team: homeTeam,
                away_team: awayTeam,
                home_players: homeTeam.players.map(({ player }) => ({
                  player,
                  goals: 0,
                  points: 0,
                  cards: []
                })),
                away_players: awayTeam.players.map(({ player }) => ({
                  player,
                  goals: 0,
                  points: 0,
                  cards: []
                })),
                round: round,
                stage: this.competition.stages.find(
                  ({ isCurrent }) => isCurrent
                )
              };
              matchesMap.set(matchKey, homeMatch);
              matchesArray.push({ home: homeMatch, away: null, key: matchKey });
            }
            if (!matchesMap.has(awayMatchKey)) {
              const awayMatch = {
                home_team: awayTeam,
                away_team: homeTeam,
                home_players: awayTeam.players.map(({ player }) => ({
                  player,
                  goals: 0,
                  points: 0,
                  cards: []
                })),
                away_players: homeTeam.players.map(({ player }) => ({
                  player,
                  goals: 0,
                  points: 0,
                  cards: []
                })),
                round: round,
                stage: this.competition.stages.find(
                  ({ isCurrent }) => isCurrent
                )
              };

              matchesMap.set(awayMatchKey, awayMatch);
              matchesArray.push({
                home: awayMatch,
                away: null,
                key: awayMatchKey
              });
            }
          }
        }
        this.teams.length % 2 === 0
          ? this.teams.splice(1, 0, this.teams.pop())
          : this.teams.splice(0, 0, this.teams.pop());
      }
    }
    let resultArray = [];
    const copyMap = new Map(JSON.parse(JSON.stringify(Array.from(matchesMap))));
    copyMap.forEach((value, key) => {
      const [homeId, awayId, roundId] = key.split("-");
      const swappedKey = `${awayId}-${homeId}-${roundId}`;
      if (copyMap.has(swappedKey)) {
        const home = value;
        const away = copyMap.get(swappedKey);
        resultArray.push({ home, away });
        copyMap.delete(key);
        copyMap.delete(swappedKey);
      }
    });
    this.circuitMatches = resultArray;
    this.updateMatches(Array.from(matchesMap.values()));
  },
  async openModal(match) {
    await this.getDisqualified(match);
    if (!this.isVisible) {
      if (this.competitionIsOngoing) {
        await this.getAllMatches(
          this.competition.stages.filter(({ isCurrent }) => isCurrent)
        );
      }
      if (this.spec === "twoway") this.checkForPairMatches();
    }
    const updatedMatch = this.matches.find(m => m._id === match._id);
    this.circuitModal = true;
    this.selectedMatch = updatedMatch;
    // this.updateWindowMatch()
  },
  async openPlayoffModal(match, arr) {
    // this.selectedMatchArr = [...arr]
    await this.getDisqualified(match);
    if (!this.isVisible) {
      if (this.competitionIsOngoing) {
        await this.getAllMatches(
          this.competition.stages.filter(({ isCurrent }) => isCurrent)
        );
      }
      if (this.spec === "twoway") this.checkForPairMatches();
    }
    const updatedMatch = arr.find(m => m._id === match._id);
    this.circuitModal = true;
    this.selectedMatch = updatedMatch;
    // this.updateMatches(this.selectedMatch);
    // this.updateWindowMatch()
  },
  async getPlayoffMatches(arg) {
    try {
      let result = [];
      for (let i = 0; i < this.rounds.filter(round => round.isPlayoff).length; i++) {
        const element = this.rounds.filter(round => round.isPlayoff)[i];
        const res = await this.$http.post("/match/list", {
          round: element._id
        });
        result.push(...res.data);
      }
      if (arg === "ladder") {
        this.ladder = result;
      } else if (arg === "wildcard") {
        this.wildcard = result;
      } else if (arg === "single") {
        this.single = result;
      }
      // this.forceRerender()
    } catch (error) {
      console.log(error);
    }
  },
  formStandings(element) {
    if (
      this.getPoints(element.home_players, element, element.home_team) >
      this.getPoints(element.away_players, element, element.away_team)
    ) {
      this.standings.push(element.home_team);
      this.standings.push(element.away_team);
    } else {
      this.standings.push(element.away_team);
      this.standings.push(element.home_team);
    }
  },
  getFinalStandings(arg) {
    if (this.standings.length !== this.teams.length) {
      if (arg === "ladder") {
        this.ladder.forEach(element => this.formStandings(element));
      } else if (arg === "wildcard") {
        if (this.groups.length === 2) {
          this.wildcard.forEach(element => {
            if (element.playoffStage === 3) this.formStandings(element);
          });
          this.wildcard.forEach(element => {
            if (element.playoffStage === 2.5) this.formStandings(element);
          });
          this.wildcard.forEach(element => {
            if (element.playoffStage === 0.5) this.formStandings(element);
          });
          this.wildcard.forEach(element => {
            if (element.playoffStage === -3) this.formStandings(element);
          });
          this.wildcard.forEach(element => {
            if (element.playoffStage === -2.5) this.formStandings(element);
          });
          this.wildcard.forEach(element => {
            if (element.playoffStage === -0.5) this.formStandings(element);
          });
          if (this.groups.every(group => group.length === 4)) {
            this.wildcard.forEach(element => {
              if (element.playoffStage === -1) this.formStandings(element);
            });
          }
          const teamsOnlyInGroups = this.groups.flat().filter(teamInGroups =>
            !this.standings.some(teamInStandings => teamInStandings._id === teamInGroups._id)
          ).sort(this.sortTeams);
          if (teamsOnlyInGroups.length)
            this.standings.push(...teamsOnlyInGroups)
        }
        if (this.groups.length === 4) {
          this.wildcard.forEach(element => {
            if (element.playoffStage === 4) this.formStandings(element);
          });
          this.wildcard.forEach(element => {
            if (element.playoffStage === 3.5) this.formStandings(element);
          });
          this.wildcard.forEach(element => {
            if (element.playoffStage === 2.75) this.formStandings(element);
          });
          this.wildcard.forEach(element => {
            if (element.playoffStage === 2.25) this.formStandings(element);
          });
          this.wildcard.forEach(element => {
            if (element.playoffStage === 1.5) this.formStandings(element);
          });
          this.wildcard.forEach(element => {
            if (element.playoffStage === 1.25) this.formStandings(element);
          });
          this.wildcard.forEach(element => {
            if (element.playoffStage === -4) this.formStandings(element);
          });
          this.wildcard.forEach(element => {
            if (element.playoffStage === -3.5) this.formStandings(element);
          });
          this.wildcard.forEach(element => {
            if (element.playoffStage === -2.75) this.formStandings(element);
          });
          this.wildcard.forEach(element => {
            if (element.playoffStage === -2.25) this.formStandings(element);
          });
          this.wildcard.forEach(element => {
            if (element.playoffStage === -1.5) this.formStandings(element);
          });
          this.wildcard.forEach(element => {
            if (element.playoffStage === -1.25) this.formStandings(element);
          });
        }
      } else if (
        arg === "single" &&
        (this.groups.length === 2 || this.groups.length === 3)
      ) {
        this.single.forEach(element => {
          if (element.playoffStage === 2) this.formStandings(element);
        });
        this.single.forEach(element => {
          if (element.playoffStage === 1.5) this.formStandings(element);
        });
        if (this.groups.length === 3) {
          this.single.forEach(element => {
            if (element.playoffStage === 0.5) this.formStandings(element);
          });
        }
        this.single.forEach(element => {
          if (element.playoffStage === -2) this.formStandings(element);
        });
        this.single.forEach(element => {
          if (element.playoffStage === -1.5) this.formStandings(element);
        });
        if (this.groups.length === 3) {
          this.single.forEach(element => {
            if (element.playoffStage === -0.5) this.formStandings(element);
          });
        }
      } else if (arg === "single" && this.groups.length === 4) {
        this.single.forEach(element => {
          if (element.playoffStage === 3) this.formStandings(element);
        });
        this.single.forEach(element => {
          if (element.playoffStage === 2.5) this.formStandings(element);
        });
        this.single.forEach(element => {
          if (element.playoffStage === 1.5) this.formStandings(element);
        });
        this.single.forEach(element => {
          if (element.playoffStage === 1.25) this.formStandings(element);
        });
        this.single.forEach(element => {
          if (element.playoffStage === -3) this.formStandings(element);
        });
        this.single.forEach(element => {
          if (element.playoffStage === -2.5) this.formStandings(element);
        });
        this.single.forEach(element => {
          if (element.playoffStage === -1.5) this.formStandings(element);
        });
        this.single.forEach(element => {
          if (element.playoffStage === -1.25) this.formStandings(element);
        });
      }
    }
  },
  getPoints(arr, match, team) {
    if (match.tech_loser) {
      if (match.tech_loser === team._id) return 0;
      else return 28;
    }
    return arr.reduce((acc, item) => acc + item.points, 0);
  },
  displayPlus(scored, conceded) {
    let diff = scored - conceded;
    if (diff > 0) {
      return "+" + diff;
    } else {
      return diff;
    }
  },
  onRemote(input) {
    console.log(input);
  },
  onGroupForm(team, group) {
    this.teams.find(t => t._id === team).group = group;
  },
  blockSave() {
    this.canSave = false
  },
  async updateTeamsGroups() {
    try {
      for (let i = 0; i < this.groups.length; i++) {
        const element = this.groups[i];
        for (let j = 0; j < element.length; j++) {
          const el = element[j];
          const res = await this.$http.post("/team/edit", {
            _id: el._id,
            group: i
          });
          if (res.data) {
            this.canSave = true
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  },
  async generateRoundRobinSchedule(src) {
    if (src) await this.updateTeamsGroups();
    const schedule = [];
    const totalRounds = this.rounds.filter(
      round => round.category === this.$route.params.cat && !round.isPlayoff
    ).length;
    for (let currentRound = 0; currentRound < totalRounds; currentRound++) {
      this.groups.forEach(group => {
        const matchesInGroup = this.generateMatchesInGroup(
          group,
          this.rounds.filter(
            round =>
              round.category === this.$route.params.cat && !round.isPlayoff
          )[currentRound]
        );
        group.length % 2 === 0
          ? group.splice(1, 0, group.pop())
          : group.splice(0, 0, group.pop());
        schedule.push(...matchesInGroup);
      });
    }

    this.updateMatches(schedule);
  },
  generateMatchesInGroup(group, round) {
    const matches = [];
    for (let i = 0; i < group.length / 2; i++) {
      if (group[i]._id !== group[group.length - 1 - i]._id) {
        const match = {
          home_team: group[i],
          away_team: group[group.length - 1 - i],
          home_players: group[i].players.map(({ player }) => {
            return { player: player, goals: 0, points: 0, cards: [] };
          }),
          away_players: group[group.length - 1 - i].players.map(
            ({ player }) => {
              return { player: player, goals: 0, points: 0, cards: [] };
            }
          ),
          stage: this.competition.stages.find(({ isCurrent }) => isCurrent),
          round: round
        };
        matches.push(match);
      }
    }

    return matches;
  },
  formMatch(home_team, away_team, playoffStage) {
    const match = {
      playoffStage: playoffStage,
      home_team: home_team,
      away_team: away_team,
      home_players: home_team.players.map(({ player }) => {
        return { player: player, goals: 0, points: 0, cards: [] };
      }),
      away_players: away_team.players.map(({ player }) => {
        return { player: player, goals: 0, points: 0, cards: [] };
      }),
      round: this.rounds.find(round => round.isPlayoff && round.category === this.$route.params.cat),
      stage: this.competition.stages.find(({ isCurrent }) => isCurrent),
      isFinished: false
    };
    return match;
  },
  async formGroups() {
    const teamsCopy = [
      ...this.teams.sort((a, b) => (a.group > b.group ? 1 : -1))
    ];
    const totalTeams = teamsCopy.length;
    const groupSize = Math.ceil(totalTeams / this.qty);
    const group = [];
    if (!this.isVisible) {
      for (let i = 0; i < Array.from(Array(this.qty)).length; i++) {
        let currentGroup = [];
        for (let j = 0; j < teamsCopy.length; j++) {
          const element = teamsCopy[j];
          if (element.group === i) currentGroup.push(element);
        }
        group.push(currentGroup);
      }
    } else {
      while (teamsCopy.length > 0) {
        group.push(teamsCopy.splice(0, groupSize));
      }
    }
    this.groups = JSON.parse(
      JSON.stringify(group.map(item => item.sort(this.sortTeams)))
    );
  },
  getSE2Final(playoffMatches, status) {
    const group1 = this.groups[0];
    const group2 = this.groups[1];
    //Final
    if (
      this.single.length &&
      this.single
        .filter(match => match.playoffStage === (status ? 1 : -1))
        .every(match => match.isFinished)
    ) {
      let finalist1;
      let finalist2;
      let match1 = this.single.filter(
        match => match.playoffStage === (status ? 1 : -1)
      )[0];
      let match2 = this.single.filter(
        match => match.playoffStage === (status ? 1 : -1)
      )[1];
      if (match1 && match2) {
        if (
          this.getPoints(match1.away_players, match1, match1.away_team) >
          this.getPoints(match1.home_players, match1, match1.home_team)
        ) {
          finalist1 = match1.away_team;
        } else {
          finalist1 = match1.home_team;
        }
        if (
          this.getPoints(match2.away_players, match2, match2.away_team) >
          this.getPoints(match2.home_players, match2, match2.home_team)
        ) {
          finalist2 = match2.away_team;
        } else {
          finalist2 = match2.home_team;
        }

        playoffMatches.push(
          this.formMatch(finalist1, finalist2, status ? 2 : -2)
        );
      }
    }

    //3rd Place
    if (
      this.single.length &&
      this.single
        .filter(match => match.playoffStage === (status ? 1 : -1))
        .every(match => match.isFinished)
    ) {
      let challenger1;
      let challenger2;
      let match1 = this.single.filter(
        match => match.playoffStage === (status ? 1 : -1)
      )[0];
      let match2 = this.single.filter(
        match => match.playoffStage === (status ? 1 : -1)
      )[1];
      if (match1 && match2) {
        if (
          this.getPoints(match1.away_players, match1, match1.away_team) <
          this.getPoints(match1.home_players, match1, match1.home_team)
        ) {
          challenger1 = match1.away_team;
        } else {
          challenger1 = match1.home_team;
        }
        if (
          this.getPoints(match2.away_players, match2, match2.away_team) <
          this.getPoints(match2.home_players, match2, match2.home_team)
        ) {
          challenger2 = match2.away_team;
        } else {
          challenger2 = match2.home_team;
        }

        playoffMatches.push(
          this.formMatch(challenger1, challenger2, status ? 1.5 : -1.5)
        );
      }
    }
    playoffMatches.push(
      this.formMatch(
        group1[status ? 0 : 2],
        group2[status ? 1 : 3],
        status ? 1 : -1
      )
    );
    playoffMatches.push(
      this.formMatch(
        group2[status ? 0 : 2],
        group1[status ? 1 : 3],
        status ? 1 : -1
      )
    );
  },
  getSE3Final(playoffMatches, status) {
    const group1 = this.groups[0];
    const group2 = this.groups[1];
    const group3 = this.groups[2];
    //Final
    if (
      this.single.length &&
      this.single
        .filter(match => match.playoffStage === (status ? 1 : -1))
        .every(match => match.isFinished)
    ) {
      let finalist1;
      let finalist2;
      let match1 = this.single.filter(
        match => match.playoffStage === (status ? 1 : -1)
      )[0];
      let match2 = this.single.filter(
        match => match.playoffStage === (status ? 1 : -1)
      )[1];
      if (match1 && match2) {
        if (
          this.getPoints(match1.away_players, match1, match1.away_team) >
          this.getPoints(match1.home_players, match1, match1.home_team)
        ) {
          finalist1 = match1.away_team;
        } else {
          finalist1 = match1.home_team;
        }
        if (
          this.getPoints(match2.away_players, match2, match2.away_team) >
          this.getPoints(match2.home_players, match2, match2.home_team)
        ) {
          finalist2 = match2.away_team;
        } else {
          finalist2 = match2.home_team;
        }

        playoffMatches.push(
          this.formMatch(finalist1, finalist2, status ? 2 : -2)
        );
      }
    }

    //3rd-4th Place Match
    if (
      this.single.length &&
      this.single
        .filter(match => match.playoffStage === (status ? 1 : -1))
        .every(match => match.isFinished)
    ) {
      let challenger1;
      let challenger2;
      let match1 = this.single.filter(
        match => match.playoffStage === (status ? 1 : -1)
      )[0];
      let match2 = this.single.filter(
        match => match.playoffStage === (status ? 1 : -1)
      )[1];
      if (match1 && match2) {
        if (
          this.getPoints(match1.away_players, match1, match1.away_team) <
          this.getPoints(match1.home_players, match1, match1.home_team)
        ) {
          challenger1 = match1.away_team;
        } else {
          challenger1 = match1.home_team;
        }
        if (
          this.getPoints(match2.away_players, match2, match2.away_team) <
          this.getPoints(match2.home_players, match2, match2.home_team)
        ) {
          challenger2 = match2.away_team;
        } else {
          challenger2 = match2.home_team;
        }

        playoffMatches.push(
          this.formMatch(challenger1, challenger2, status ? 1.5 : -1.5)
        );
      }
    }

    //5-6th Place Match
    const deciders = [
      group1[status ? 1 : 3],
      group2[status ? 1 : 3],
      group3[status ? 1 : 3]
    ];
    const challengers = deciders.filter(
      team => team._id !== this.getTeamWithHighestScore(...deciders)._id
    );
    let home_challenger;
    let away_challenger;
    if (this.getDecider(...challengers)._id === challengers[0]._id) {
      home_challenger = challengers[0];
      away_challenger = challengers[1];
    } else {
      home_challenger = challengers[1];
      away_challenger = challengers[0];
    }
    playoffMatches.push(
      this.formMatch(home_challenger, away_challenger, status ? 0.5 : -0.5)
    );
    //Semifinals
    playoffMatches.push(
      this.formMatch(
        group1[status ? 0 : 2],
        group2[status ? 0 : 2],
        status ? 1 : -1
      )
    );

    playoffMatches.push(
      this.formMatch(
        group3[status ? 0 : 2],
        this.getTeamWithHighestScore(...deciders),
        status ? 1 : -1
      )
    );
  },
  getSE4Final(playoffMatches, status) {
    const group1 = this.groups[0];
    const group2 = this.groups[1];
    const group3 = this.groups[2];
    const group4 = this.groups[3];

    //Final
    if (
      this.single.length &&
      this.single
        .filter(match => match.playoffStage === (status ? 2 : -2))
        .every(match => match.isFinished)
    ) {
      let finalist1;
      let finalist2;
      let match1 = this.single.filter(
        match => match.playoffStage === (status ? 2 : -2)
      )[0];
      let match2 = this.single.filter(
        match => match.playoffStage === (status ? 2 : -2)
      )[1];
      if (match1 && match2) {
        if (
          this.getPoints(match1.away_players, match1, match1.away_team) >
          this.getPoints(match1.home_players, match1, match1.home_team)
        ) {
          finalist1 = match1.away_team;
        } else {
          finalist1 = match1.home_team;
        }
        if (
          this.getPoints(match2.away_players, match2, match2.away_team) >
          this.getPoints(match2.home_players, match2, match2.home_team)
        ) {
          finalist2 = match2.away_team;
        } else {
          finalist2 = match2.home_team;
        }
        playoffMatches.push(
          this.formMatch(finalist1, finalist2, status ? 3 : -3)
        );
      }
    }
    //3rd Place Match
    if (
      this.single.length &&
      this.single
        .filter(match => match.playoffStage === (status ? 2 : -2))
        .every(match => match.isFinished)
    ) {
      let challenger1;
      let challenger2;
      let match1 = this.single.filter(
        match => match.playoffStage === (status ? 2 : -2)
      )[0];
      let match2 = this.single.filter(
        match => match.playoffStage === (status ? 2 : -2)
      )[1];
      if (match1 && match2) {
        if (
          this.getPoints(match1.away_players, match1, match1.away_team) <
          this.getPoints(match1.home_players, match1, match1.home_team)
        ) {
          challenger1 = match1.away_team;
        } else {
          challenger1 = match1.home_team;
        }
        if (
          this.getPoints(match2.away_players, match2, match2.away_team) <
          this.getPoints(match2.home_players, match2, match2.home_team)
        ) {
          challenger2 = match2.away_team;
        } else {
          challenger2 = match2.home_team;
        }
        playoffMatches.push(
          this.formMatch(challenger1, challenger2, status ? 2.5 : -2.5)
        );
      }
    }

    //Winner Semifinals
    if (
      this.single.length &&
      this.single
        .filter(match => match.playoffStage === (status ? 1 : -1))
        .every(match => match.isFinished)
    ) {
      let semifinalist1;
      let semifinalist2;
      let semifinalist3;
      let semifinalist4;
      let match1 = this.single.filter(
        match => match.playoffStage === (status ? 1 : -1)
      )[0];
      let match2 = this.single.filter(
        match => match.playoffStage === (status ? 1 : -1)
      )[1];
      let match3 = this.single.filter(
        match => match.playoffStage === (status ? 1 : -1)
      )[2];
      let match4 = this.single.filter(
        match => match.playoffStage === (status ? 1 : -1)
      )[3];
      if (match1 && match2) {
        if (
          this.getPoints(match1.away_players, match1, match1.away_team) >
          this.getPoints(match1.home_players, match1, match1.home_team)
        ) {
          semifinalist1 = match1.away_team;
        } else {
          semifinalist1 = match1.home_team;
        }
        if (
          this.getPoints(match2.away_players, match2, match2.away_team) >
          this.getPoints(match2.home_players, match2, match2.home_team)
        ) {
          semifinalist2 = match2.away_team;
        } else {
          semifinalist2 = match2.home_team;
        }
        playoffMatches.push(
          this.formMatch(semifinalist1, semifinalist2, status ? 2 : -2)
        );
      }
      if (match3 && match4) {
        if (
          this.getPoints(match3.away_players, match3, match3.away_team) >
          this.getPoints(match3.home_players, match3, match3.home_team)
        ) {
          semifinalist3 = match3.away_team;
        } else {
          semifinalist3 = match3.home_team;
        }
        if (
          this.getPoints(match4.away_players, match4, match4.away_team) >
          this.getPoints(match4.home_players, match4, match4.home_team)
        ) {
          semifinalist4 = match4.away_team;
        } else {
          semifinalist4 = match4.home_team;
        }

        playoffMatches.push(
          this.formMatch(semifinalist3, semifinalist4, status ? 2 : -2)
        );
      }
    }
    //5th Place Match
    if (
      this.single.length &&
      this.single
        .filter(match => match.playoffStage === (status ? 0.5 : -0.5))
        .every(match => match.isFinished)
    ) {
      let challenger1;
      let challenger2;
      let match1 = this.single.filter(
        match => match.playoffStage === (status ? 0.5 : -0.5)
      )[0];
      let match2 = this.single.filter(
        match => match.playoffStage === (status ? 0.5 : -0.5)
      )[1];
      if (match1 && match2) {
        if (
          this.getPoints(match1.away_players, match1, match1.away_team) >
          this.getPoints(match1.home_players, match1, match1.home_team)
        ) {
          challenger1 = match1.away_team;
        } else {
          challenger1 = match1.home_team;
        }
        if (
          this.getPoints(match2.away_players, match2, match2.away_team) >
          this.getPoints(match2.home_players, match2, match2.home_team)
        ) {
          challenger2 = match2.away_team;
        } else {
          challenger2 = match2.home_team;
        }

        playoffMatches.push(
          this.formMatch(challenger1, challenger2, status ? 1.5 : -1.5)
        );
      }
    }
    //7th Place Match
    if (
      this.single.length &&
      this.single
        .filter(match => match.playoffStage === (status ? 0.5 : -0.5))
        .every(match => match.isFinished)
    ) {
      let challenger1;
      let challenger2;
      let match1 = this.single.filter(
        match => match.playoffStage === (status ? 0.5 : -0.5)
      )[0];
      let match2 = this.single.filter(
        match => match.playoffStage === (status ? 0.5 : -0.5)
      )[1];
      if (match1 && match2) {
        if (
          this.getPoints(match1.away_players, match1, match1.away_team) <
          this.getPoints(match1.home_players, match1, match1.home_team)
        ) {
          challenger1 = match1.away_team;
        } else {
          challenger1 = match1.home_team;
        }
        if (
          this.getPoints(match2.away_players, match2, match2.away_team) <
          this.getPoints(match2.home_players, match2, match2.home_team)
        ) {
          challenger2 = match2.away_team;
        } else {
          challenger2 = match2.home_team;
        }

        playoffMatches.push(
          this.formMatch(challenger1, challenger2, status ? 1.25 : -1.25)
        );
      }
    }

    //Loser Semifinals
    if (
      this.single.length &&
      this.single
        .filter(match => match.playoffStage === (status ? 1 : -1))
        .every(match => match.isFinished)
    ) {
      let semifinalist1;
      let semifinalist2;
      let semifinalist3;
      let semifinalist4;
      let match1 = this.single.filter(
        match => match.playoffStage === (status ? 1 : -1)
      )[0];
      let match2 = this.single.filter(
        match => match.playoffStage === (status ? 1 : -1)
      )[1];
      let match3 = this.single.filter(
        match => match.playoffStage === (status ? 1 : -1)
      )[2];
      let match4 = this.single.filter(
        match => match.playoffStage === (status ? 1 : -1)
      )[3];
      if (match1 && match2) {
        if (
          this.getPoints(match1.away_players, match1, match1.away_team) <
          this.getPoints(match1.home_players, match1, match1.home_team)
        ) {
          semifinalist1 = match1.away_team;
        } else {
          semifinalist1 = match1.home_team;
        }
        if (
          this.getPoints(match2.away_players, match2, match2.away_team) <
          this.getPoints(match2.home_players, match2, match2.home_team)
        ) {
          semifinalist2 = match2.away_team;
        } else {
          semifinalist2 = match2.home_team;
        }

        playoffMatches.push(
          this.formMatch(semifinalist1, semifinalist2, status ? 0.5 : -0.5)
        );
      }
      if (match3 && match4) {
        if (
          this.getPoints(match3.away_players, match3, match3.away_team) <
          this.getPoints(match3.home_players, match3, match3.home_team)
        ) {
          semifinalist3 = match3.away_team;
        } else {
          semifinalist3 = match3.home_team;
        }
        if (
          this.getPoints(match4.away_players, match4, match4.away_team) <
          this.getPoints(match4.home_players, match4, match4.home_team)
        ) {
          semifinalist4 = match4.away_team;
        } else {
          semifinalist4 = match4.home_team;
        }

        playoffMatches.push(
          this.formMatch(semifinalist3, semifinalist4, status ? 0.5 : -0.5)
        );
      }
    }
    //Quarterfinals
    playoffMatches.push(
      this.formMatch(
        group1[status ? 0 : 2],
        group2[status ? 1 : 3],
        status ? 1 : -1
      )
    );
    playoffMatches.push(
      this.formMatch(
        group2[status ? 0 : 2],
        group1[status ? 1 : 3],
        status ? 1 : -1
      )
    );
    playoffMatches.push(
      this.formMatch(
        group3[status ? 0 : 2],
        group4[status ? 1 : 3],
        status ? 1 : -1
      )
    );
    playoffMatches.push(
      this.formMatch(
        group4[status ? 0 : 2],
        group3[status ? 1 : 3],
        status ? 1 : -1
      )
    );
  },
  getWC2Final(playoffMatches, status) {
    const group1 = this.groups[0];
    const group2 = this.groups[1];
    if (
      this.wildcard.length &&
      this.wildcard
        .filter(match => match.playoffStage === (status ? 2 : -2))
        .every(match => match.isFinished)
    ) {
      //FINAL
      let finalist1;
      let finalist2;
      let match1 = this.wildcard.filter(
        match => match.playoffStage === (status ? 2 : -2)
      )[0];
      let match2 = this.wildcard.filter(
        match => match.playoffStage === (status ? 2 : -2)
      )[1];
      if (match1 && match2) {
        if (
          this.getPoints(match1.away_players, match1, match1.away_team) >
          this.getPoints(match1.home_players, match1, match1.home_team)
        ) {
          finalist1 = match1.away_team;
        } else {
          finalist1 = match1.home_team;
        }
        if (
          this.getPoints(match2.away_players, match2, match2.away_team) >
          this.getPoints(match2.home_players, match2, match2.home_team)
        ) {
          finalist2 = match2.away_team;
        } else {
          finalist2 = match2.home_team;
        }

        playoffMatches.push(
          this.formMatch(finalist1, finalist2, status ? 3 : -3)
        );
      }
    }
    if (
      this.wildcard.length &&
      this.wildcard
        .filter(match => match.playoffStage === (status ? 2 : -2))
        .every(match => match.isFinished)
    ) {
      //3rd Place Match
      let challenger1;
      let challenger2;
      let match1 = this.wildcard.filter(
        match => match.playoffStage === (status ? 2 : -2)
      )[0];
      let match2 = this.wildcard.filter(
        match => match.playoffStage === (status ? 2 : -2)
      )[1];
      if (match1 && match2) {
        if (
          this.getPoints(match1.away_players, match1, match1.away_team) <
          this.getPoints(match1.home_players, match1, match1.home_team)
        ) {
          challenger1 = match1.away_team;
        } else {
          challenger1 = match1.home_team;
        }
        if (
          this.getPoints(match2.away_players, match2, match2.away_team) <
          this.getPoints(match2.home_players, match2, match2.home_team)
        ) {
          challenger2 = match2.away_team;
        } else {
          challenger2 = match2.home_team;
        }
        playoffMatches.push(
          this.formMatch(challenger1, challenger2, status ? 2.5 : -2.5)
        );
      }
    }
    if (
      this.wildcard.length &&
      this.wildcard
        .filter(match => match.playoffStage === (status ? 1 : -1))
        .every(match => match.isFinished)
    ) {
      // Semifinals
      let winner1;
      let match1 = this.wildcard.filter(
        match => match.playoffStage === (status ? 1 : -1)
      )[0];
      if (
        this.getPoints(match1.away_players, match1, match1.away_team) >
        this.getPoints(match1.home_players, match1, match1.home_team)
      ) {
        winner1 = match1.away_team;
      } else {
        winner1 = match1.home_team;
      }
      playoffMatches.push(this.formMatch(group1[status ? 0 : 3], winner1, status ? 2 : -2));
      let winner2;
      let match2 = this.wildcard.filter(
        match => match.playoffStage === (status ? 1 : -1)
      )[1];
      if (
        this.getPoints(match2.away_players, match2, match2.away_team) >
        this.getPoints(match2.home_players, match2, match2.home_team)
      ) {
        winner2 = match2.away_team;
      } else {
        winner2 = match2.home_team;
      }
      playoffMatches.push(this.formMatch(group2[status ? 0 : 3], winner2, status ? 2 : -2));
    }
    if (
      this.wildcard.length &&
      this.wildcard
        .filter(match => match.playoffStage === (status ? 1 : -1))
        .every(match => match.isFinished)
    ) {
      // Wildcard Losers Game
      let loser1;
      let match1 = this.wildcard.filter(
        match => match.playoffStage === (status ? 1 : -1)
      )[0];
      if (
        this.getPoints(match1.away_players, match1, match1.away_team) <
        this.getPoints(match1.home_players, match1, match1.home_team)
      ) {
        loser1 = match1.away_team;
      } else {
        loser1 = match1.home_team;
      }
      let loser2;
      let match2 = this.wildcard.filter(
        match => match.playoffStage === (status ? 1 : -1)
      )[1];
      if (
        this.getPoints(match2.away_players, match2, match2.away_team) <
        this.getPoints(match2.home_players, match2, match2.home_team)
      ) {
        loser2 = match2.away_team;
      } else {
        loser2 = match2.home_team;
      }
      playoffMatches.push(this.formMatch(loser1, loser2, status ? 0.5 : -0.5));
    }
    // Wildcard
    playoffMatches.push(
      this.formMatch(
        group1[status ? 1 : 4],
        group2[status ? 2 : 5],
        status ? 1 : -1
      )
    );
    playoffMatches.push(
      this.formMatch(
        group2[status ? 1 : 4],
        group1[status ? 2 : 5],
        status ? 1 : -1
      )
    );
  },
  getWC4Final(playoffMatches, status) {
    const group1 = this.groups[0];
    const group2 = this.groups[1];
    const group3 = this.groups[2];
    const group4 = this.groups[3];

    playoffMatches.push(
      this.formMatch(
        group1[status ? 1 : 4],
        group2[status ? 2 : 5],
        status ? 1 : -1
      )
    );
    playoffMatches.push(
      this.formMatch(
        group2[status ? 1 : 4],
        group1[status ? 2 : 5],
        status ? 1 : -1
      )
    );
    playoffMatches.push(
      this.formMatch(
        group3[status ? 1 : 4],
        group4[status ? 2 : 5],
        status ? 1 : -1
      )
    );
    playoffMatches.push(
      this.formMatch(
        group4[status ? 1 : 4],
        group3[status ? 2 : 5],
        status ? 1 : -1
      )
    );

    // Wildcard Losers
    if (
      this.wildcard.length &&
      this.wildcard
        .filter(match => match.playoffStage === (status ? 1 : -1))
        .every(match => match.isFinished)
    ) {
      let loser1;
      let loser2;
      let loser3;
      let loser4;

      let match1 = this.wildcard.filter(
        match => match.playoffStage === (status ? 1 : -1)
      )[0];
      let match2 = this.wildcard.filter(
        match => match.playoffStage === (status ? 1 : -1)
      )[1];
      let match3 = this.wildcard.filter(
        match => match.playoffStage === (status ? 1 : -1)
      )[2];
      let match4 = this.wildcard.filter(
        match => match.playoffStage === (status ? 1 : -1)
      )[3];

      if (match1 && match2 && match3 && match4) {
        if (
          this.getPoints(match1.away_players, match1, match1.away_team) <
          this.getPoints(match1.home_players, match1, match1.home_team)
        ) {
          loser1 = match1.away_team;
        } else {
          loser1 = match1.home_team;
        }
        if (
          this.getPoints(match2.away_players, match2, match2.away_team) <
          this.getPoints(match2.home_players, match2, match2.home_team)
        ) {
          loser2 = match2.away_team;
        } else {
          loser2 = match2.home_team;
        }
        if (
          this.getPoints(match3.away_players, match3, match3.away_team) <
          this.getPoints(match3.home_players, match3, match3.home_team)
        ) {
          loser3 = match3.away_team;
        } else {
          loser3 = match3.home_team;
        }
        if (
          this.getPoints(match4.away_players, match4, match4.away_team) <
          this.getPoints(match4.home_players, match4, match4.home_team)
        ) {
          loser4 = match4.away_team;
        } else {
          loser4 = match4.home_team;
        }

        playoffMatches.push(
          this.formMatch(loser1, loser2, status ? 0.5 : -0.5)
        );
        playoffMatches.push(
          this.formMatch(loser3, loser4, status ? 0.5 : -0.5)
        );
      }
    }

    // 9-12 Place Matches
    if (
      this.wildcard.length &&
      this.wildcard
        .filter(match => match.playoffStage === (status ? 0.5 : -0.5))
        .every(match => match.isFinished)
    ) {
      let loser1;
      let loser2;
      let winner1;
      let winner2;

      let match1 = this.wildcard.filter(
        match => match.playoffStage === (status ? 0.5 : -0.5)
      )[0];
      let match2 = this.wildcard.filter(
        match => match.playoffStage === (status ? 0.5 : -0.5)
      )[1];
      if (match1 && match2) {
        if (
          this.getPoints(match1.away_players, match1, match1.away_team) <
          this.getPoints(match1.home_players, match1, match1.home_team)
        ) {
          loser1 = match1.away_team;
          winner1 = match1.home_team;
        } else {
          loser1 = match1.home_team;
          winner1 = match1.away_team;
        }
        if (
          this.getPoints(match2.away_players, match2, match2.away_team) <
          this.getPoints(match2.home_players, match2, match2.home_team)
        ) {
          loser2 = match2.away_team;
          winner2 = match2.home_team;
        } else {
          loser2 = match2.home_team;
          winner2 = match2.away_team;
        }
        playoffMatches.push(
          this.formMatch(loser1, loser2, status ? 1.25 : -1.25)
        );
        playoffMatches.push(
          this.formMatch(winner1, winner2, status ? 1.5 : -1.5)
        );
      }
    }

    // 1/4 game
    if (
      this.wildcard.length &&
      this.wildcard
        .filter(match => match.playoffStage === (status ? 1 : -1))
        .every(match => match.isFinished)
    ) {
      let quarterfinalist1;
      let quarterfinalist2;
      let quarterfinalist3;
      let quarterfinalist4;

      let match1 = this.wildcard.filter(
        match => match.playoffStage === (status ? 1 : -1)
      )[0];
      let match2 = this.wildcard.filter(
        match => match.playoffStage === (status ? 1 : -1)
      )[1];
      let match3 = this.wildcard.filter(
        match => match.playoffStage === (status ? 1 : -1)
      )[2];
      let match4 = this.wildcard.filter(
        match => match.playoffStage === (status ? 1 : -1)
      )[3];

      if (match1 && match2 && match3 && match4) {
        if (
          this.getPoints(match1.away_players, match1, match1.away_team) >
          this.getPoints(match1.home_players, match1, match1.home_team)
        ) {
          quarterfinalist1 = match1.away_team;
        } else {
          quarterfinalist1 = match1.home_team;
        }
        if (
          this.getPoints(match2.away_players, match2, match2.away_team) >
          this.getPoints(match2.home_players, match2, match2.home_team)
        ) {
          quarterfinalist2 = match2.away_team;
        } else {
          quarterfinalist2 = match2.home_team;
        }
        if (
          this.getPoints(match3.away_players, match3, match3.away_team) >
          this.getPoints(match3.home_players, match3, match3.home_team)
        ) {
          quarterfinalist3 = match3.away_team;
        } else {
          quarterfinalist3 = match3.home_team;
        }
        if (
          this.getPoints(match4.away_players, match4, match4.away_team) >
          this.getPoints(match4.home_players, match4, match4.home_team)
        ) {
          quarterfinalist4 = match4.away_team;
        } else {
          quarterfinalist4 = match4.home_team;
        }
        playoffMatches.push(
          this.formMatch(
            group1[status ? 0 : 3],
            quarterfinalist1,
            status ? 2 : -2
          )
        );
        playoffMatches.push(
          this.formMatch(
            group2[status ? 0 : 3],
            quarterfinalist2,
            status ? 2 : -2
          )
        );
        playoffMatches.push(
          this.formMatch(
            group3[status ? 0 : 3],
            quarterfinalist3,
            status ? 2 : -2
          )
        );
        playoffMatches.push(
          this.formMatch(
            group4[status ? 0 : 3],
            quarterfinalist4,
            status ? 2 : -2
          )
        );
      }
    }

    // Quarterfinals Losers
    if (
      this.wildcard.length &&
      this.wildcard
        .filter(match => match.playoffStage === (status ? 2 : -2))
        .every(match => match.isFinished)
    ) {
      let loser1;
      let loser2;
      let loser3;
      let loser4;

      let match1 = this.wildcard.filter(
        match => match.playoffStage === (status ? 2 : -2)
      )[0];
      let match2 = this.wildcard.filter(
        match => match.playoffStage === (status ? 2 : -2)
      )[1];
      let match3 = this.wildcard.filter(
        match => match.playoffStage === (status ? 2 : -2)
      )[2];
      let match4 = this.wildcard.filter(
        match => match.playoffStage === (status ? 2 : -2)
      )[3];

      if (match1 && match2 && match3 && match4) {
        if (
          this.getPoints(match1.away_players, match1, match1.away_team) <
          this.getPoints(match1.home_players, match1, match1.home_team)
        ) {
          loser1 = match1.away_team;
        } else {
          loser1 = match1.home_team;
        }
        if (
          this.getPoints(match2.away_players, match2, match2.away_team) <
          this.getPoints(match2.home_players, match2, match2.home_team)
        ) {
          loser2 = match2.away_team;
        } else {
          loser2 = match2.home_team;
        }
        if (
          this.getPoints(match3.away_players, match3, match3.away_team) <
          this.getPoints(match3.home_players, match3, match3.home_team)
        ) {
          loser3 = match3.away_team;
        } else {
          loser3 = match3.home_team;
        }
        if (
          this.getPoints(match4.away_players, match4, match4.away_team) <
          this.getPoints(match4.home_players, match4, match4.home_team)
        ) {
          loser4 = match4.away_team;
        } else {
          loser4 = match4.home_team;
        }
        playoffMatches.push(
          this.formMatch(loser1, loser2, status ? 2.5 : -2.5)
        );
        playoffMatches.push(
          this.formMatch(loser3, loser4, status ? 2.5 : -2.5)
        );
      }
    }

    //5-8 Place Matches
    if (
      this.wildcard.length &&
      this.wildcard
        .filter(match => match.playoffStage === (status ? 2.5 : -2.5))
        .every(match => match.isFinished)
    ) {
      let loser1;
      let loser2;
      let winner1;
      let winner2;

      let match1 = this.wildcard.filter(
        match => match.playoffStage === (status ? 2.5 : -2.5)
      )[0];
      let match2 = this.wildcard.filter(
        match => match.playoffStage === (status ? 2.5 : -2.5)
      )[1];
      if (match1 && match2) {
        if (
          this.getPoints(match1.away_players, match1, match1.away_team) <
          this.getPoints(match1.home_players, match1, match1.home_team)
        ) {
          loser1 = match1.away_team;
          winner1 = match1.home_team;
        } else {
          loser1 = match1.home_team;
          winner1 = match1.away_team;
        }
        if (
          this.getPoints(match2.away_players, match2, match2.away_team) <
          this.getPoints(match2.home_players, match2, match2.home_team)
        ) {
          loser2 = match2.away_team;
          winner2 = match2.home_team;
        } else {
          loser2 = match2.home_team;
          winner2 = match2.away_team;
        }
        playoffMatches.push(
          this.formMatch(loser1, loser2, status ? 2.25 : -2.25)
        );
        playoffMatches.push(
          this.formMatch(winner1, winner2, status ? 2.75 : -2.75)
        );
      }
    }

    // Semifinals
    if (
      this.wildcard.length &&
      this.wildcard
        .filter(match => match.playoffStage === (status ? 2 : -2))
        .every(match => match.isFinished)
    ) {
      let semiFinalist1;
      let semiFinalist2;
      let semiFinalist3;
      let semiFinalist4;

      let match1 = this.wildcard.filter(
        match => match.playoffStage === (status ? 2 : -2)
      )[0];
      let match2 = this.wildcard.filter(
        match => match.playoffStage === (status ? 2 : -2)
      )[1];
      let match3 = this.wildcard.filter(
        match => match.playoffStage === (status ? 2 : -2)
      )[2];
      let match4 = this.wildcard.filter(
        match => match.playoffStage === (status ? 2 : -2)
      )[3];

      if (match1 && match2) {
        if (
          this.getPoints(match1.away_players, match1, match1.away_team) >
          this.getPoints(match1.home_players, match1, match1.home_team)
        ) {
          semiFinalist1 = match1.away_team;
        } else {
          semiFinalist1 = match1.home_team;
        }
        if (
          this.getPoints(match2.away_players, match2, match2.away_team) >
          this.getPoints(match2.home_players, match2, match2.home_team)
        ) {
          semiFinalist2 = match2.away_team;
        } else {
          semiFinalist2 = match2.home_team;
        }

        if (
          this.getPoints(match3.away_players, match3, match3.away_team) >
          this.getPoints(match3.home_players, match3, match3.home_team)
        ) {
          semiFinalist3 = match3.away_team;
        } else {
          semiFinalist3 = match3.home_team;
        }

        if (
          this.getPoints(match4.away_players, match4, match4.away_team) >
          this.getPoints(match4.home_players, match4, match4.home_team)
        ) {
          semiFinalist4 = match4.away_team;
        } else {
          semiFinalist4 = match4.home_team;
        }
        playoffMatches.push(
          this.formMatch(semiFinalist1, semiFinalist2, status ? 3 : -3)
        );
        playoffMatches.push(
          this.formMatch(semiFinalist3, semiFinalist4, status ? 3 : -3)
        );
      }
    }

    //3rd Place Match
    if (
      this.wildcard.length &&
      this.wildcard
        .filter(match => match.playoffStage === (status ? 3 : -3))
        .every(match => match.isFinished)
    ) {
      let challenger1;
      let challenger2;

      let match1 = this.wildcard.filter(
        match => match.playoffStage === (status ? 3 : -3)
      )[0];
      let match2 = this.wildcard.filter(
        match => match.playoffStage === (status ? 3 : -3)
      )[1];

      if (match1 && match2) {
        if (
          this.getPoints(match1.away_players, match1, match1.away_team) <
          this.getPoints(match1.home_players, match1, match1.home_team)
        ) {
          challenger1 = match1.away_team;
        } else {
          challenger1 = match1.home_team;
        }
        if (
          this.getPoints(match2.away_players, match2, match2.away_team) <
          this.getPoints(match2.home_players, match2, match2.home_team)
        ) {
          challenger2 = match2.away_team;
        } else {
          challenger2 = match2.home_team;
        }

        playoffMatches.push(
          this.formMatch(challenger1, challenger2, status ? 3.5 : -3.5)
        );
      }
    }

    //FINAL
    if (
      this.wildcard.length &&
      this.wildcard
        .filter(match => match.playoffStage === (status ? 3 : -3))
        .every(match => match.isFinished)
    ) {
      let finalist1;
      let finalist2;

      let match1 = this.wildcard.filter(
        match => match.playoffStage === (status ? 3 : -3)
      )[0];
      let match2 = this.wildcard.filter(
        match => match.playoffStage === (status ? 3 : -3)
      )[1];

      if (match1 && match2) {
        if (
          this.getPoints(match1.away_players, match1, match1.away_team) >
          this.getPoints(match1.home_players, match1, match1.home_team)
        ) {
          finalist1 = match1.away_team;
        } else {
          finalist1 = match1.home_team;
        }
        if (
          this.getPoints(match2.away_players, match2, match2.away_team) >
          this.getPoints(match2.home_players, match2, match2.home_team)
        ) {
          finalist2 = match2.away_team;
        } else {
          finalist2 = match2.home_team;
        }
        playoffMatches.push(
          this.formMatch(finalist1, finalist2, status ? 4 : -4)
        );
      }
    }
  },
  async singlePlayoffMatches() {
    const playoffMatches = [];
    if (this.groups.length === 2) {
      // ============================== 2 groups - 2 semifinals - Winner Bracket ==============================
      this.getSE2Final(playoffMatches, true);
      // ============================== 2 groups - 2 semifinals - Consolation Bracket ==============================
      if (this.groups.every(group => group.length >= 4)) {
        this.getSE2Final(playoffMatches, false);
      } else if (this.groups.every(group => group.length === 3)) {
        playoffMatches.push(
          this.formMatch(this.groups[0][2], this.groups[1][2], -1)
        );
      }
    } else if (this.groups.length === 3) {
      // ============================== 3 groups - 2 semifinals - Winner Bracket ==============================
      this.getSE3Final(playoffMatches, true);
      // ============================== 3 groups - 2 semifinals - Consolation Bracket ==============================
      if (this.groups.every(group => group.length >= 4)) {
        this.getSE3Final(playoffMatches, false);
      }
    } else if (this.groups.length === 4) {
      // ============================== 4 groups - 4 quarterfinals - Winner Bracket ==============================

      this.getSE4Final(playoffMatches, true);
      // ============================== 4 groups - 4 quarterfinals - Consolation Bracket ==============================
      if (this.groups.every(group => group.length === 4)) {
        this.getSE4Final(playoffMatches, false);
      } else if (this.groups.every(group => group.length === 3)) {
        playoffMatches.push(
          this.formMatch(this.groups[0][2], this.groups[1][2], -1)
        );
        playoffMatches.push(
          this.formMatch(this.groups[2][2], this.groups[3][2], -1)
        );
        if (
          this.single.length &&
          this.single
            .filter(match => match.playoffStage === -1)
            .every(match => match.isFinished)
        ) {
          let winner1;
          let winner2;
          let loser1;
          let loser2;

          let match1 = this.single.filter(
            match => match.playoffStage === -1
          )[0];
          let match2 = this.single.filter(
            match => match.playoffStage === -1
          )[1];

          if (match1 && match2) {
            if (
              this.getPoints(match1.away_players, match1, match1.away_team) >
              this.getPoints(match1.home_players, match1, match1.home_team)
            ) {
              winner1 = match1.away_team;
              loser1 = match1.home_team;
            } else {
              winner1 = match1.home_team;
              loser1 = match1.away_team;
            }
            if (
              this.getPoints(match2.away_players, match2, match2.away_team) >
              this.getPoints(match2.home_players, match2, match2.home_team)
            ) {
              winner2 = match2.away_team;
              loser2 = match2.home_team;
            } else {
              winner2 = match2.home_team;
              loser2 = match2.away_team;
            }
            playoffMatches.push(this.formMatch(winner1, winner2, -3));
            playoffMatches.push(this.formMatch(loser1, loser2, -2.5));
          }
        }
      }
    }
    let playoffStages = [
      2,
      -2,
      3,
      -3,
      0.5,
      -0.5,
      1.25,
      -1.25,
      1.5,
      -1.5,
      2.5,
      -2.5,
      3.5,
      -3.5
    ];
    if (!this.single.length && playoffMatches.length) {
      try {
        await this.$http.post("/match/addManyToPlayoff", playoffMatches);
      } catch (error) {
        console.log(error);
      }
    }
    for (let i = 0; i < playoffStages.length; i++) {
      const stage = playoffStages[i];
      if (
        this.single.length &&
        playoffMatches.filter(match => match.playoffStage === stage).length &&
        !this.single.some(match => match.playoffStage === stage)
      ) {
        try {
          await this.$http.post(
            "/match/addManyToPlayoff",
            playoffMatches.filter(match => match.playoffStage === stage)
          );
        } catch (error) {
          console.log(error);
        }
      }
    }
    await this.getPlayoffMatches('single')
  },
  async ladderPlayoffMatches() {
    const playoffMatches = [];

    if (this.groups.length === 2) {
      const group1 = this.groups[0];
      const group2 = this.groups[1];

      for (let i = 0; i < Math.min(group1.length, group2.length); i++) {
        playoffMatches.push({
          title: `${this.$t("competition.match_for")} ${i + i + 1}-${i +
            i +
            2}`,
          stage: this.competition.stages.find(({ isCurrent }) => isCurrent),
          round: this.rounds.find(round => round.isPlayoff),
          home_team: group1[i],
          away_team: group2[i],
          home_players: group1[i].players.map(({ player }) => {
            return { player: player, goals: 0, points: 0, cards: [] };
          }),
          away_players: group2[i].players.map(({ player }) => {
            return { player: player, goals: 0, points: 0, cards: [] };
          }),
          isFinished: false
        });
      }
    }
    if (!this.ladder.length) {
      try {
        const match = await this.$http.post("/match/addManyToPlayoff", playoffMatches);
        this.ladder.push(...match.data);
      } catch (error) {
        console.log(error);
      }
    }
  },
  async wildCardPlayoffMatches() {
    const playoffMatches = [];
    if (this.groups.length % 2 === 0) {
      if (this.groups.length === 2) {
        this.getWC2Final(playoffMatches, true);

        if (this.groups.every(group => group.length >= 6)) {
          this.getWC2Final(playoffMatches, false);
        } else if (this.groups.every(group => group.length === 4)) {
          playoffMatches.push(
            this.formMatch(this.groups[0][3], this.groups[1][3], -1)
          );
        }
      }
      // ====================================================== WILDCARD =======================================================

      if (this.groups.length === 4) {
        // ==========================  4 groups - 4 semifinals - Winner Bracket  ==========================
        this.getWC4Final(playoffMatches, true);
        // ==========================  4 groups - 4 semifinals - Consolation Bracket  ==========================
        if (this.groups.every(group => group.length >= 6)) {
          this.getWC4Final(playoffMatches, false);
        } else if (this.groups.every(group => group.length === 4)) {
          playoffMatches.push(
            this.formMatch(this.groups[0][3], this.groups[1][3], -1)
          );
          playoffMatches.push(
            this.formMatch(this.groups[2][3], this.groups[3][3], -1)
          );
          if (
            this.wildcard.length &&
            this.wildcard
              .filter(match => match.playoffStage === -1)
              .every(match => match.isFinished)
          ) {
            let winner1;
            let winner2;
            let loser1;
            let loser2;

            let match1 = this.wildcard.filter(
              match => match.playoffStage === -1
            )[0];
            let match2 = this.wildcard.filter(
              match => match.playoffStage === -1
            )[1];

            if (match1 && match2) {
              if (
                this.getPoints(match1.away_players, match1, match1.away_team) >
                this.getPoints(match1.home_players, match1, match1.home_team)
              ) {
                winner1 = match1.away_team;
                loser1 = match1.home_team;
              } else {
                winner1 = match1.home_team;
                loser1 = match1.away_team;
              }
              if (
                this.getPoints(match2.away_players, match2, match2.away_team) >
                this.getPoints(match2.home_players, match2, match2.home_team)
              ) {
                winner2 = match2.away_team;
                loser2 = match2.home_team;
              } else {
                winner2 = match2.home_team;
                loser2 = match2.away_team;
              }
              playoffMatches.push(this.formMatch(winner1, winner2, -4));
              playoffMatches.push(this.formMatch(loser1, loser2, -3.5));
            }
          }
        }
      }
    }

    let playoffStages = [
      2,
      -2,
      3,
      -3,
      4,
      -4,
      0.5,
      -0.5,
      1.25,
      -1.25,
      1.5,
      -1.5,
      2.25,
      -2.25,
      2.5,
      -2.5,
      2.75,
      -2.75,
      3.5,
      -3.5
    ];
    if (!this.wildcard.length && playoffMatches.length) {
      try {
        await this.$http.post("/match/addManyToPlayoff", playoffMatches);
      } catch (error) {
        console.log(error);
      }
    }
    for (let i = 0; i < playoffStages.length; i++) {
      const stage = playoffStages[i];
      if (
        this.wildcard.length &&
        playoffMatches.filter(match => match.playoffStage === stage).length &&
        !this.wildcard.some(match => match.playoffStage === stage)
      ) {
        try {
          await this.$http.post(
            "/match/addManyToPlayoff",
            playoffMatches.filter(match => match.playoffStage === stage)
          );
        } catch (error) {
          console.log(error);
        }
      }
    }
  },
  getTeamWithHighestScore(a, b, c) {
    if (a.statistics.points > b.statistics.points) {
      if (a.statistics.points > c.statistics.points) {
        return a;
      } else if (a.statistics.points < c.statistics.points) {
        return c;
      } else {
        return a.statistics.scored - a.statistics.conceded >
          c.statistics.scored - c.statistics.conceded
          ? a
          : c;
      }
    } else if (a.statistics.points < b.statistics.points) {
      if (b.statistics.points > c.statistics.points) {
        return b;
      } else if (b.statistics.points < c.statistics.points) {
        return c;
      } else {
        return b.statistics.scored - b.statistics.conceded >
          c.statistics.scored - c.statistics.conceded
          ? b
          : c;
      }
    } else {
      let decider =
        a.statistics.scored - a.statistics.conceded >
          b.statistics.scored - b.statistics.conceded
          ? a
          : b;
      if (decider.statistics.points > c.statistics.points) {
        return decider;
      } else if (decider.statistics.points < c.statistics.points) {
        return c;
      } else {
        return decider.statistics.scored - decider.statistics.conceded >
          c.statistics.scored - c.statistics.conceded
          ? decider
          : c;
      }
    }
  },
  getDecider(a, b) {
    if (a.statistics.points > b.statistics.points) {
      return a;
    } else if (a.statistics.points < b.statistics.points) {
      return b;
    } else {
      return a.statistics.scored - a.statistics.conceded >
        b.statistics.scored - b.statistics.conceded
        ? a
        : b;
    }
  },
  sortTeams(a, b) {
    if (a.statistics && b.statistics) {
      if (a.statistics.points !== b.statistics.points) {
        return b.statistics.points - a.statistics.points;
      }
      if (
        a.statistics.scored - a.statistics.conceded !==
        b.statistics.scored - b.statistics.conceded
      ) {
        return (
          b.statistics.scored -
          b.statistics.conceded -
          (a.statistics.scored - a.statistics.conceded)
        );
      }
    }
    if (a.name && b.name) {
      return a.name.localeCompare(b.name);
    }
    return 0;
  },
  async goToPlayoffs() {
    if (this.matches.every(match => match.isFinished)) {
      console.log("calledPlayoffs");
      this.groupStageFinished = true;

      if (this.spec === 'stepladder') {
        await this.getPlayoffMatches("ladder");
        if (!this.ladder.length) {
          await this.ladderPlayoffMatches();
          window.location.reload()
        }
      }
      else if (this.spec === 'single') {
        await this.getPlayoffMatches("single");
        if (!this.single.length) {
          await this.singlePlayoffMatches();
          // window.location.reload()
        }
      }
      else if (this.spec === 'wildcard') {
        await this.getPlayoffMatches("wildcard");
        if (!this.wildcard.length) {
          await this.wildCardPlayoffMatches();
          // window.location.reload()
        }
      }
    }
  },
  getWidth() {
    let widthHeader = $('.main-content')[0];
    let resizeObserver = new ResizeObserver((widthEl) => {
      if (widthEl[0].contentRect.width > 1400) {
        this.spanCount = '6'
      } else {
        this.spanCount = '12'
      }
    });
    resizeObserver.observe(widthHeader);
  },
  async finishCompetition() {
    try {
      await this.$http.post("/competition/finish", { _id: this.competition._id })
      window.location.reload()
    } catch (error) {
      console.log(error);
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/competitions/schemes/formats/storeMixin.js